import React, { useState, useEffect } from "react";
import { object, oneOf } from "prop-types";
import get from "lodash/get";

import Headline from "../../atoms/headline";

import { getEntity } from "../../helper/api";

import "./project-funding-partner.m.css";

const ProjectFundingPartner = ({ story, type }) => {
  const [list, setList] = useState([]);

  useEffect(() => {
    const attributeList = get(story, ["metadata", "story-attributes", type], []);

    if (!attributeList.length) {
      return;
    }

    const apiCallbackList = [];
    const entityList = [];

    for (let index = 0; index < attributeList.length; index++) {
      const element = attributeList[index];
      apiCallbackList.push(getEntity(element.id));
    }

    Promise.all(apiCallbackList).then(responses => {
      responses.forEach(results => entityList.push(results));

      setList(entityList.filter(c => c));
    });
  }, []);

  if (!list.length) {
    return null;
  }

  return (
    <div styleName="wrapper" className="project-funding-partner-wrapper">
      <Headline headerType={7} headerLevel={2} text={type === "funding" ? "Project Funding" : "Partners"} />

      <ul styleName="content">
        {list.map((item, index) => (
          <li key={index}>
            {item.link || item.url ? (
              <a target="_blank" rel="noopener noreferrer" href={item.link || item.url} key={index}>
                {item.name}
              </a>
            ) : (
              <a key={index}>{item.name}</a>
            )}
          </li>
        ))}
      </ul>
    </div>
  );
};

ProjectFundingPartner.propTypes = {
  story: object.isRequired,
  type: oneOf(["funding", "partners"])
};

export default ProjectFundingPartner;
